import { Clickable, Col, Icon, Text } from 'components';
import { capitalize, formatLocale, theme } from 'lib';
import { memo, useState } from 'react';
import { TableComponents } from 'screens/Admin/components';
import styled from 'styled-components';
import { Menu } from './';

const ActionButton = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  border: 1px solid ${theme.GREY_20};
  border-radius: 999px;
  background: #fff;
`;

const ListItem = memo(({ item, dataId, onClick = null, onDelete = null }) => {
  const [menuVisible, setMenuVisible] = useState(false);
  const isSelected = dataId === item._id,
    { from, user, sport } = item;

  const sportMap = {
    americanFootball: 'American Football',
    baseball: 'Baseball',
    basketball: 'Basketball',
    boxing: 'Boxing',
    cricket: 'Cricket',
    soccer: 'Soccer',
    // Legacy rows stored soccer as 'football'.
    football: 'Soccer',
    mma: 'MMA',
    carRace: 'Car Race'
  };

  /**
   * Determine label for media type
   * @param {JSON} media
   * @returns {string}
   */
  function mediaType(media) {
    if (media && media.uri) {
      const ext = media.uri.toLowerCase().split('.').pop();

      switch (ext) {
        case 'ogg':
          return 'Audio';
        case 'ogv':
        case 'webm':
        case 'mp4':
          return 'Video';
        case 'webp':
        case 'jpg':
        case 'jpeg':
        case 'png':
          return 'Image';
      }
    }

    return 'Text';
  }

  return (
    <TableComponents.Tr onClick={() => onClick(item._id)} isSelected={isSelected}>
      <TableComponents.Td isSelected={isSelected} first>
        <Text>{from?.name}</Text>
        <Text c1 col={theme.GREY_60}>
          @{from?.username}
        </Text>
      </TableComponents.Td>

      <TableComponents.Td isSelected={isSelected}>
        <Col noFlex>
          <Text>{capitalize(sport ? sportMap[sport] : '')}</Text>
        </Col>
      </TableComponents.Td>

      <TableComponents.Td isSelected={isSelected} first>
        <Col noFlex>
          <Text>{capitalize(user?.type)}</Text>
        </Col>
      </TableComponents.Td>

      <TableComponents.Td isSelected={isSelected} first>
        <Text>{user?.name}</Text>
        {!user?.dummy && (
          <Text c1 col={theme.GREY_60}>
            @{user?.username}
          </Text>
        )}
      </TableComponents.Td>

      <TableComponents.Td isSelected={isSelected}>
        <Col noFlex>
          <Text>{mediaType(item.media)}</Text>
        </Col>
      </TableComponents.Td>

      <TableComponents.Td isSelected={isSelected}>
        <Col noFlex>
          <Text>
            {item.createdAt ? formatLocale(new Date(item.createdAt), 'LLL do yyy, hh:mm a') : ''}
          </Text>
        </Col>
      </TableComponents.Td>
      <TableComponents.Td
        wid="120px"
        isSelected={isSelected}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <Col noFlex>
          <Clickable
            goThrough
            onClick={() => {
              setMenuVisible(!menuVisible);
            }}
          >
            <ActionButton>
              <Text c1 med col={theme.GREY_80}>
                Options
              </Text>
              <Icon type="menu" dimensions={12} col={theme.GREY_80} />
            </ActionButton>
          </Clickable>
        </Col>
        <Menu
          shoutoutId={item._id}
          message={item.comment}
          visible={menuVisible}
          onDelete={(id) => {
            setMenuVisible(false);
            onDelete?.(id);
          }}
          close={() => {
            setMenuVisible(false);
          }}
        />
      </TableComponents.Td>
    </TableComponents.Tr>
  );
});

export default ListItem;
